import { EntityType } from '@audacy-clients/client-services/core';
import isArray from 'lodash/isArray';

import { formatPublishDate } from '~/utils/date';

interface IFormatEyebrowParams {
  publishDate?: Date;
  updateDate?: Date;
  subtitle?: string | string[];
  entityType?: EntityType;
}

export const formatEyebrow = ({
  publishDate,
  updateDate,
  subtitle,
  entityType,
}: IFormatEyebrowParams): string[] => {
  let eyebrow = [];

  if (publishDate && entityType !== EntityType.COLLECTION) {
    eyebrow.push(formatPublishDate(publishDate));
  }

  if (entityType === EntityType.COLLECTION && updateDate) {
    eyebrow.push(formatPublishDate(updateDate));
  }

  if (subtitle) {
    if (isArray(subtitle)) {
      eyebrow = [...eyebrow, ...subtitle];
    } else {
      eyebrow.push(subtitle);
    }
  }
  return eyebrow;
};
